import CropBoard from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/3Crop/CropBoard';
import FertilizationBoard from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/4Fertilization/FertilizationBoard';
import MineralizationBoard from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/5Mineralization/MineralizationBoard';
import StatusBoard from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/Standart/StatusBoard';
import { BoardSteps } from 'utils/constants';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';
import { Country } from 'utils/types';

import { GermanStatusBoard } from './components/1Status/German/GermanStatusBoard';
import { GermanSoilBoard } from './components/2Soil/GermanSoilBoard';
import SoilBoard from './components/2Soil/SoilBoard';
import { GermanCropBoard } from './components/3Crop/GermanCropBoard';

interface BoardStepProps {
  isPDF?: boolean;
}

export const BoardStep = ({ isPDF }: BoardStepProps) => {
  const { user, step } = useCroptimizer();
  const isGerman = user?.country?.name === Country.Germany;

  const renderBoard = () => {
    switch (step) {
      case BoardSteps.status:
        return <>{isGerman ? <GermanStatusBoard /> : <StatusBoard />}</>;
      case BoardSteps.soil:
        return (
          <>
            {isGerman ? (
              <GermanSoilBoard isPDF={isPDF} />
            ) : (
              <SoilBoard isPDF={isPDF} />
            )}
          </>
        );
      case BoardSteps.crop:
        return (
          <>
            {isGerman ? (
              <GermanCropBoard isPDF={isPDF} isGerman />
            ) : (
              <CropBoard isPDF={isPDF} />
            )}
          </>
        );
      
      // INFO in light version Fertilization and Mineralization boards are in the crop board step
      case BoardSteps.fertilization:
        return <FertilizationBoard isPDF={isPDF} />;
      case BoardSteps.mineralization:
        return <MineralizationBoard isPDF={isPDF} isGerman={isGerman}/>;
    }
  };

  return <>{renderBoard()}</>;
};
